module.exports = __webpack_public_path__ + "img/sy-act.19b4dba8.png";